import styled from 'styled-components'

interface PInTableListProps {
    fontSize?: string
    isDeleted?: boolean
}
export const PInTableList = styled.div<PInTableListProps>`
    font-size: ${(props) => props.fontSize || '10px'};
    margin: 0;
    border-bottom: 1px solid #d0d3ea;
    text-decoration: ${(props) => props.isDeleted ? "line-through" : ""}
    i {
        margin-left: 5px;
        color:red:
    }
`
